import { Header2, Header4 } from '@cian/ui-kit/typography';
import React, { memo } from 'react';

import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';
import styles from './Title.css';

interface ITitleProps {
  title: string;
  subtitle?: string;
  isTop: boolean;
  isHighlighted?: boolean;
}

export const TitleComponent: React.FC<ITitleProps> = ({ title, subtitle, isTop, isHighlighted }) => {
  return (
    <GeneralInfoSectionRow>
      <Header2 data-mark="OfferTitle" color={isTop || subtitle !== undefined ? 'primary_100' : 'black_100'}>
        <span className={isHighlighted ? styles['title-highlighted'] : ''}>{title}</span>
      </Header2>
      {subtitle && (
        <div className={styles['subtitle']}>
          <Header4 data-mark="OfferSubtitle">{subtitle}</Header4>
        </div>
      )}
    </GeneralInfoSectionRow>
  );
};

TitleComponent.displayName = 'Title';

export const Title = memo(TitleComponent);
